module.exports = __webpack_public_path__ + "static/list-2f6158b4bac22702ef609a59f3b8fbae.png";